import { render, staticRenderFns } from "./siteFoot.vue?vue&type=template&id=72ee4466&scoped=true&"
import script from "./siteFoot.vue?vue&type=script&lang=js&"
export * from "./siteFoot.vue?vue&type=script&lang=js&"
import style0 from "./siteFoot.vue?vue&type=style&index=0&id=72ee4466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ee4466",
  null
  
)

export default component.exports